import { useMatch } from 'react-router';
import { IndependentIraAssets, IraUserAssets } from 'screens';
import {
  ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_ASSETS,
  ROUTE_CONTRIBUTION_DETAIL_IRA_USER_ASSETS,
} from 'constants/routes';

const ContributionDetailUserAssets = (): JSX.Element => {
  const isIRAUser = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_USER_ASSETS);
  const isIRAAccount = useMatch(ROUTE_CONTRIBUTION_DETAIL_IRA_ACCOUNT_ASSETS);

  if (isIRAUser) {
    return <IraUserAssets />;
  }
  if (isIRAAccount) {
    return <IndependentIraAssets />;
  }
  return <></>;
};

export default ContributionDetailUserAssets;
